//品类规格定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 品类规格
 */
class Spec extends UltMeta {
    COARSE = new Meta(1, "粗砂");
    RAW = new Meta(2, "中砂");
    FINE = new Meta(3, "细砂");
    EXTRA_FINE = new Meta(4, "特细砂");
}

export const SPEC = new Spec();
/**
 * 区域类型
 */
class Region extends UltMeta {
    CHONGQING_REGION = new Meta(1, "重庆地区");
    HUBEI_REGION = new Meta(2, "湖北地区");
    HUNAN_REGION = new Meta(3, "湖南地区");
    JIANGXI_REGION = new Meta(4, "江西地区");
    ANHUI_REGION = new Meta(5, "安徽地区");
    ZHEJIANG_REGION = new Meta(6, "浙江地区");
}
export const REGION = new Region();
/**
 * 品类类型
 */
class productTypeState extends UltMeta {
    NATURAL_SAND = new Meta(1, "天然砂");
    MACHINE_MADE_SAND = new Meta(2, "机制砂");
    MACADAM = new Meta(3, "碎石");
}
export const PRODUCT_TYPE_STATE = new productTypeState();
